var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen pb-14 bg-right bg-cover bg-gray-100",style:({ backgroundImage: `url(${require('@/assets/img/bg.svg')})` })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }